var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraggableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5H13",
    stroke: "#A5B3BD",
    strokeWidth: 0.166667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7H13",
    stroke: "#A5B3BD",
    strokeWidth: 0.166667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9H13",
    stroke: "#A5B3BD",
    strokeWidth: 0.166667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.5L6.5 0L9 2.5H4Z",
    fill: "#A5B3BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.5L6.5 14L9 11.5H4Z",
    fill: "#A5B3BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggableIcon);
export default __webpack_public_path__ + "static/media/draggable-icon.548e61b5764fc73387ecbdc8142ae64d.svg";
export { ForwardRef as ReactComponent };